import React, { useEffect, useState, useCallback, useRef } from 'react';
import { FormHandles } from '@unform/core';
import { FiSearch, FiMoreVertical } from 'react-icons/fi';
import { ImTicket } from 'react-icons/im';
import { IoTicketOutline } from 'react-icons/io5';
import {
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  IconButton,
	Flex,
} from '@chakra-ui/react';

import api from '../../services/api';
import { useAuth } from '../../hooks/auth';
import { formatPrice } from '../../utils/format';
import Sidebar from '../../components/Sidebar';
import Loading from '../../components/Loading';
import ModalCupom from '../../components/CupomComponents/ModalCupom';
import ModalCupomRemove from '../../components/CupomComponents/ModalCupomRemove';
import Button from '../../components/Button';
import InputDate from '../../components/Inputs/InputDate';
import InputSelect from '../../components/Inputs/Selects/InputSelect';

import {
  Container,
  Content,
  Header,
  Filtros,
  FormView,
  CupomList,
  CupomItem,
  NenhumCupom,
} from './styles';

type DateData = {
	status: string;
	data_i: string;
	data_f: string;
};
type CupomData = {
  cat: number;
  cod_cupom: string;
  cod_desc: string;
  cupom: string;
  dat_cadastro: string;
  formapg: string;
  id_cliente: string;
  id_desconto: string;
  nome: string;
  orig: string;
  prim: string;
  primeira_comp: string;
  selec_est: string;
  tip: string;
  val: number;
  val_min: number;
  validade: string;
  valor: string;
  vencimento: string;
  vlr_minimo: string;
  venda_perc: number;
  venda_qtd: number;
  venda_tkm: number;
  venda_vlr: number;
}
const optionsStatus = [
  { id: 'T', label: 'Todos' },
  { id: 'A', label: 'Ativos' },
  { id: 'I', label: 'Inativos' },
];

const Cupom: React.FC = () => {
  const formRef = useRef<FormHandles>(null);
  const { company, permissions } = useAuth();

  const [loading, setLoading] = useState(false);
  const [loadingList, setLoadingList] = useState(false);
  const [cupons, setCupons] = useState<CupomData[]>([]);
  const [modalCupomVisible, setModalCupomVisible] = useState(false);
  const [modalCupomRemoveVisible, setModalCupomRemoveVisible] = useState(false);
  const [cupomModal, setCupomModal] = useState<CupomData>({} as CupomData);

  const handleGetCupons = useCallback(async (data: DateData) => {
    setLoadingList(true);

    await api
      .post('portal/cupom/index', {
        tipo: data.status,
        data_i: data.data_i,
        data_f: data.data_f,
      })
      .then(response => {
        setCupons(response.data);
      })
      .finally(() => {
        setLoading(false);
        setLoadingList(false);
      });
  }, []);

  useEffect(() => {
    setLoading(true);
    handleGetCupons({ status: 'T', data_i: '', data_f: '' });
  }, [handleGetCupons, company]);

  return (
    <>
      <Container>
				<Sidebar />
				
        {loading ? (
          <Loading />
        ) : (
          <>
            {loadingList && <Loading />}

            <Content>
              <Header>
                <div>
                  <h1>Cupons de desconto.</h1>
                  <h2>Crie aqui seus cupons de desconto para seus clientes.</h2>
                </div>

								{permissions.incluir && (
									<Button
										onClick={() => {
											setCupomModal({} as CupomData);
											setModalCupomVisible(true);
										}}
										style={{
											padding: '0 30px',
											whiteSpace: 'nowrap',
											width: 'auto',
										}}
									>
										+ Novo
									</Button>
								)}
              </Header>

              {cupons.length > 0 ? (
                <>
                  <Filtros>
                    <FormView ref={formRef} onSubmit={handleGetCupons}>
											<Flex mr={[0, 2, 2, 2]} width="100%">
												<div className="input-content">
													<span>Data Inicial</span>
													<InputDate
														name="data_i"
														placeholder="Data Inicial"
														containerStyle={{ padding: '7px ' }}
													/>
												</div>
											
												<div className="input-content">
													<span>Data Final</span>
													<InputDate
														name="data_f"
														placeholder="Data Final"
														containerStyle={{ padding: '7px ' }}
													/>
												</div>
											</Flex>
                 
								 			<Flex>
												<div className="input-content">
													<span>Status</span>
													<InputSelect
														name="status"
														placeholder="Status"
														options={optionsStatus}
														defaultValue="T"
														containerStyle={{
															padding: '8px 7px',
															paddingRight: '17px ',
														}}
													/>
												</div>

													<div className="input-content input-content-button">
													<span>&nbsp;</span>
													<button type="submit">
														<FiSearch /> Pesquisar
													</button>
												</div>
											</Flex>
                    </FormView>
                  </Filtros>

                  <CupomList>
                    {cupons.map((cupom, indice) => (
                      <CupomItem key={indice}>
                        <div className="cupom-title">
                          <div>
                            <ImTicket />

                            <span>{cupom.valor}</span>
                          </div>

													{(permissions.alterar || permissions.excluir) && (
														<div>
															<Menu>
																{({ isOpen }) => (
																	<>
																		<MenuButton
																			className="menu-button"
																			as={IconButton}
																			isActive={isOpen}
																			aria-label="Options"
																			icon={<FiMoreVertical />}
																			variant="outline"
																		/>

																		<MenuList className="menu-list">
																			{permissions.alterar && (
																				<MenuItem
																					className="item"
																					onClick={() => {
																						setCupomModal(cupom);
																						setModalCupomVisible(true);
																					}}
																				>
																					Editar
																				</MenuItem>
																			)}

																			{permissions.excluir && (
																				<MenuItem
																					className="item"
																					onClick={() => {
																						setCupomModal(cupom);
																						setModalCupomRemoveVisible(true);
																					}}
																				>
																					Excluir
																				</MenuItem>
																			)}
																		</MenuList>
																	</>
																)}
															</Menu>
														</div>
													)}
                        </div>

                        <div className="cupom-rules">
                          <div className="rules">
                            <p>{cupom.nome}</p>
                            <p>Código: {cupom.cod_desc}</p>
                            <p>{cupom.cupom}</p>
                            <p>{cupom.primeira_comp}</p>
                            <p>{cupom.vlr_minimo}</p>
                          </div>

                          <div className="dados">
                            <p>
                              Perc. Venda:&nbsp;&nbsp;
                              <span>{cupom.venda_perc}%</span>
                            </p>
                            <p>
                              Qtd Venda:&nbsp;&nbsp;
                              <span>{cupom.venda_qtd}</span>
                            </p>
                            <p>
                              Ticket médio:&nbsp;&nbsp;
                              <span>{formatPrice(cupom.venda_tkm)}</span>
                            </p>
                            <p>
                              Valor:&nbsp;&nbsp;
                              <span>{formatPrice(cupom.venda_vlr)}</span>
                            </p>
                          </div>
                        </div>

                        <div className="cupom-dates">
                          <div className="inicio">
                            <span className="label">Criado em</span>
                            <span>{cupom.dat_cadastro}</span>
                          </div>

                          <div className="fim">
                            <span className="label">Válido até</span>
                            <span>{cupom.validade}</span>
                          </div>
                        </div>
                      </CupomItem>
                    ))}
                  </CupomList>
                </>
              ) : (
                <NenhumCupom>
                  <IoTicketOutline />
                  <h1>Nenhum cupom de desconto cadastrado no momento.</h1>
                  <h2>
                    Aqui você pode cadastrar os cupons de desconto para os seus
                    clientes
                  </h2>
                </NenhumCupom>
              )}
            </Content>
          </>
        )}
      </Container>

      {modalCupomVisible && (
        <ModalCupom
          onClose={() => setModalCupomVisible(false)}
          isVisible={modalCupomVisible}
          setCupons={setCupons}
          cupom={cupomModal}
        />
      )}
      {modalCupomRemoveVisible && (
        <ModalCupomRemove
          onClose={() => setModalCupomRemoveVisible(false)}
          isVisible={modalCupomRemoveVisible}
          cupom={cupomModal}
          setCupons={setCupons}
          setLoadingList={setLoadingList}
        />
      )}
    </>
  );
};

export default Cupom;
